const QueryKeys = {
  Assessments: 'Assessments',
  CompletedStatus: 'CompletedStatus',
  Correlations: 'Correlations',
  GlossaryTerms: 'GlossaryTerms',
  ImageModels: 'ImageModels',
  Lessons: 'Lessons',
  ModelReferenceMaterials: 'ModelReferenceMaterials',
  Mutations: {
    Delete: 'Delete',
    Patch: 'Patch',
    Post: 'Post',
  },
  ProgramStates: 'ProgramStates',
  Programs: 'Programs',
  ReferenceMaterial: 'ReferenceMaterial',
  ReferenceMaterials: 'ReferenceMaterials',
  ScoresData: 'ScoresData',
  Slide: 'Slide',
  SlideShowQuestionGroups: 'SlideShowQuestionGroups',
  SlideShows: 'SlideShows',
  States: 'States',
  ThemeCss: 'ThemeCss',
  UseClassrooms: 'useClassrooms',
  UseProfessionalDevelopmentResults: 'useProfessionalDevelopmentResults',
  UseStyleSheets: 'useStyleSheets',
  UseTeacherNotes: 'UseTeacherNotes',
  UseThemes: 'useThemes',
  UseThreeDModel: 'useThreeDModel',
} as const;

export default QueryKeys;
